import { useSelector } from 'react-redux';
import { getNumTiles } from '../../../../modules/Redux';
import { useWindowSize } from './useWindowSize';
import { useMemo } from 'react';

const calculateFontSize = (numTiles: number): number => {
    if (numTiles <= 5) {
        return 44;
    } else if (numTiles <= 10) {
        return 36;
    } else if (numTiles <= 15) {
        return 33;
    } else if (numTiles <= 20) {
        return 30;
    } else if (numTiles <= 25) {
        return 26;
    } else if (numTiles <= 30) {
        return 24;
    } else if (numTiles <= 35) {
        return 22;
    } else {
        return 18;
    }
};

// ELC dimensions 1920 x 1080

export const useAutoFontSize = () => {
    const numTiles = useSelector(getNumTiles);
    const windowSize = useWindowSize();

    // Memoize the calculation of font size and scale
    return useMemo(() => {
        const sqrt = Math.sqrt(
            (windowSize.width || 0) * (windowSize.height || 0)
        );

        const fontSize = calculateFontSize(numTiles);

        // A base scale calculated from the sqrt of the window area of the ELC
        const baseScale = sqrt / 1440;

        // Damping factor to make scale converge towards 1
        // You can adjust this value to tune the convergence speed
        // increase dampingFactor to make scale converge faster, meaning
        // the font size will be smaller for larger window sizes
        const dampingFactor = 1;
        const scale = 1 + (baseScale - 1) * dampingFactor;

        const scaledFontSize = Math.floor(fontSize * scale);
        // console.log('scale', scale);
        // console.log('scaledFontSize', scaledFontSize);
        // console.log('numTiles', numTiles);
        return {
            fontSize: scaledFontSize,
            scale,
            sqrt,
        };
    }, [numTiles, windowSize.width, windowSize.height]);
};
